import { SavedArtworkModel, SavedArtworkPageModel } from '@models/types'

import { Box } from '@domain-group/suit-theme'
import SavedArtworkListItem from '../../SavedArtworks/components/SavedArtworkListItem'
import SavedArtworkPageListItem from '../../SavedArtworkPages/components/SavedArtworkPageListItem'

type ListViewProps = {
  entities: SavedArtworkPageModel[] | SavedArtworkModel[],
}

const ListView = (props: ListViewProps) => {
  const { entities } = props

  const Component = entities[0].type === 'SavedArtwork' ? SavedArtworkListItem : SavedArtworkPageListItem

  return (
    <Box flexDirection="column">
      {entities.map(
        entity => <Component entity={entity} key={entity.id} />,
      )}
    </Box>
  )
}

export default ListView
